import React from 'react';
import { Box, useColorMode, Image, Input } from '@chakra-ui/react';
import { connect } from 'react-redux';

//Assets

import enterIconDark from '../../../../../assets/cardui/entericon_dark.svg';
import enterIconLight from '../../../../../assets/cardui/entericon_light.svg';
import defaultPlaceholderIconDark from '../../../../../assets/cardui/defaultplaceholder_dark.svg';
import defaultPlaceholderIconLight from '../../../../../assets/cardui/defaultplaceholder_light.svg';
import placeholderInstructionsDark from '../../../../../assets/cardui/placeholder_instructions_dark.svg';

//Components

import TypeSelectorSearch from './PlaceholderTypeContainer';
import InstructionSection from './InstructionSection';
import ItemRightInstructions from './ItemInstructions';
import { setVibrateInstructions } from '../../../../../redux/actions/cardui';
import { truncate } from 'lodash-es';

//Functions
//Functions
import getCurrentPlaceholdersDetails from '../../../../../functions/commandBar/getCurrentPlaceholdersDetails';

const InitialItem = ({ selected, text, type }) => {
	const { colorMode } = useColorMode();
	const bgColorSelected = {
		light: 'card_ui.focus_light',
		dark: 'card_ui.focus_dark',
	};
	const color = {
		light: 'card_ui.font_light.200',
		dark: 'card_ui.font_dark.200',
	};
	const enterIcon = {
		light: enterIconLight,
		dark: enterIconDark,
	};
	const defaultPlaceholderIcon = {
		light: defaultPlaceholderIconLight,
		dark: defaultPlaceholderIconDark,
	};
	const dividerColor = {
		light: 'card_ui.divider_light',
		dark: 'card_ui.divider_dark',
	};

	const bgColor = {
		light: 'card_ui.placeholder_light',
		dark: 'card_ui.placeholder_dark',
	};
	let ifMultiplePlaceholders = getCurrentPlaceholdersDetails().multiple;
	return (
		<Box
			paddingY="1.5rem"
			paddingLeft="0.8rem"
			height="2rem"
			display="flex"
			alignItems="center"
			bg={selected ? bgColorSelected[colorMode] : 'none'}
			borderRight="solid 3px"
			borderRightColor={selected ? '#9B51E0' : 'transparent'}
			borderTop={'solid 1px'}
			justifyContent="space-between"
			borderTopColor={dividerColor[colorMode]}
			// roundedBottom={lastItem ? "1rem" : "0rem"}
		>
			<Box display="flex" alignItems="center">
				<Image
					src={defaultPlaceholderIcon[colorMode]}
					size="1.1rem"
					ml={2}
				/>
				<Box
					height="1.3rem"
					bg={bgColor[colorMode]}
					paddingX="0.7rem"
					paddingY="0.1rem"
					borderRadius="0.2rem"
					display="flex"
					justifyContent="center"
					alignItems="center"
					ml={5}
					cursor="pointer"
					color={color[colorMode]}
					_focus={{ outline: 'none' }}
					whiteSpace="nowrap"
					mb={1}
					mt={1}
				>
					<Input
						color={color[colorMode]}
						whiteSpace="nowrap"
						bg={bgColor[colorMode]}
						fontWeight="600"
						cursor="pointer"
						height="80%"
						padding="0"
						border="none"
						borderRadius="none"
						contentEditable
						textAlign={'center'}
						fontSize="0.9rem"
						value={type}
						onChange={() => {}}
						width={`${type.length * 0.55}rem`}
						_placeholder={{ color: '#777777' }}
						placeholder={type}
						_focus={{ outline: 'none' }}
						fontFamily="body"
					/>
				</Box>
				<Box
					display="flex"
					alignItems="center"
					ml={3}
					fontSize="0.9rem"
					fontFamily="body"
					fontWeight="600"
					flexWrap={'wrap'}
					color={color[colorMode]}
					whiteSpace="nowrap"
					textOverflow="ellipsis"
				>
					{text ? truncate(text, { length: 31 }) : 'Start typing...'}
				</Box>
			</Box>

			{selected ? (
				<ItemRightInstructions
					text={ifMultiplePlaceholders ? 'Shift + Enter' : 'Enter'}
				/>
			) : null}
		</Box>
	);
};

const PlaceholderSearchList = ({
	placeholderType,
	placeholderText,
	selectedIndex,
	vibrateInstructions,
	setVibrateInstructions,
	intentObjectArray,
}) => {
	return (
		<Box
			onMouseDown={(e) => {
				e.preventDefault();
				setVibrateInstructions(true);
				setTimeout(() => setVibrateInstructions(false), 500);
				const placeholderObjId = intentObjectArray.allIds.find((id) => {
					if (intentObjectArray?.byId[id]?.ref?.current) return true;
					return false;
				});
				if (placeholderObjId)
					intentObjectArray.byId[placeholderObjId].ref.current.select();
			}}
		>
			<InitialItem
				text={placeholderText}
				type={placeholderType}
				selected={selectedIndex === 0}
			/>
			<TypeSelectorSearch />
			<InstructionSection
				vibrate={vibrateInstructions}
				children={
					<Image
						src={placeholderInstructionsDark}
						height="1.2rem"
						mr={3}
					/>
				}
			/>
		</Box>
	);
};

// <Box
//         height="1.8rem"
//         display="flex"
//         alignItems="center"
//         pl={5}
//         fontSize="0.8rem"
//         fontFamily="body"
//         fontWeight="400"
//         color={color[colorMode]}
//       >
//         <Icon name="search" />
//         <Box ml={5}>{`Searching for "${placeholderType}" type...`}</Box>
//       </Box>

const mapStateToProps = (state) => {
	let { placeholderText, vibrateInstructions } =
		state.cardUI.centerSearch.middle;
	let { selectedIndex } =
		state.cardUI.centerSearch.middle.placeholderSearchList;
	const { intentObjectArray } = state.cardUI.centerSearch.top;
	return {
		placeholderText,
		selectedIndex,
		vibrateInstructions,
		intentObjectArray,
	};
};

export default connect(mapStateToProps, { setVibrateInstructions })(
	PlaceholderSearchList
);
